export default __webpack_public_path__ + "static/media/new-Emi-Banner.a6e6ccd1.jpg";